import isEqual from "react-fast-compare";

export { isEqual };
